// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .disabled > button[data-v-52278705] {\n  cursor: no-drop;\n}\n", ""]);
// Exports
module.exports = exports;
